import React from 'react';
import PropTypes from 'prop-types';
import './_styles.scss';
import { Button } from '../../packages/components';
import Asset from '../../requests/apa/Asset';
import Translator from '../../requests/apa/Translator';

const backArrow = 'MenuAvatar_Icono_ChevronOff';
const hoverBackArrow = 'MenuAvatar_Icono_ChevronOn';

const ConfigButtonAssets = {
    backArrow,
    hoverBackArrow,
};

const ConfigMenuButton = ({ labelKey, onClick, onFocus }) => {
    const { backArrow, hoverBackArrow } = ConfigButtonAssets;

    return (
        <Button className="config-button focusable" onClick={onClick} onFocus={onFocus}>
            <p>{Translator.get(labelKey)}</p>
            <img
                className="config-button__chevron config-button__chevron--normal"
                src={Asset.get(backArrow)}
            />
            {hoverBackArrow && (
                <img
                    className="config-button__chevron config-button__chevron--hover"
                    src={Asset.get(hoverBackArrow)}
                />
            )}
        </Button>
    );
};

ConfigMenuButton.propTypes = {
    labelKey: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
};

export default ConfigMenuButton;


// WEBPACK FOOTER //
// ./src/components/ConfigMenuButton/ConfigMenuButton.jsx